export default "__VITE_ASSET__D7wLuFS9__"